
import { useEffect } from 'react'
import { supabase } from '@/integrations/supabase/client'

export const useModuleRealtime = (onModuleChange: () => void) => {
  useEffect(() => {
    // Set up real-time subscription for module changes
    const channel = supabase
      .channel('learn_modules_changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'learn_modules'
        },
        (payload) => {
          console.log('Real-time module change:', payload)
          // Immediately refetch to ensure we have the latest data
          onModuleChange()
        }
      )
      .subscribe((status) => {
        console.log('Real-time subscription status:', status)
      })

    return () => {
      console.log('Cleaning up real-time subscription')
      supabase.removeChannel(channel)
    }
  }, [onModuleChange])
}
